<div class="tabs-container">
  @for (tab of tabs(); track tab.value) {
    <div
      class="tab-item"
      [ngClass]="{
        selected: tab.value === selectedTab()
      }"
      (click)="selectTab(tab.value)"
    >
      <span class="icon" [ngClass]="[tab.icon]"></span>
      <span>{{ tab.value }}</span>
    </div>
  }
</div>
